import {customElement, property, state} from "lit/decorators";
import {html, LitElement, nothing} from "lit";
import pdqDataBroker from "../services/PdqDataBroker";

import '@carbon/web-components/es/components/copy-button/index.js';
import '@carbon/web-components/es/components/icon-button/index.js';
import '@carbon/web-components/es/components/textarea/index.js';
import Icon from '@carbon/web-components/es/icons/debug/16.js';

import Debug from "debug";
import { DONT_TRIGGER_UPDATE, IObservable, ReplaySubject } from '../observable/ReplaySubject';
import {View} from "@finos/perspective";
import {col, grow, hide, margin, padding, row} from "../styles";
import pdqHotkeyService from "../services/PdqHotkeyService";
import {PdqDiscoverable, pdqDiscoveryLayer} from "./_pdq-mixin";
import {TAG_TYPE} from "@carbon/web-components/es/components/tag/defs";
const log = Debug('pdq:flow:pdq-dump');
@customElement('pdq-dump')
@pdqDiscoveryLayer(log, Icon, 'pdq-dump', 'rgba(255, 83, 236, 0.13)', TAG_TYPE.GREEN)
export class PdqDump extends LitElement implements PdqDiscoverable{
    static styles = [hide, row, col, grow, padding, margin]
    @property() show: boolean = false;
    @state() dataPreview = 'no data';

    #view: string | undefined = undefined;
    #table: string | undefined = undefined;

    @property() error: string | null = null;

    @property()
    get view() {
        return this.#view || '';
    }

    set view(value: string) {
        this.#view = value;
        this.updateData()
    }

    @property()
    get table() {
        return this.#table || '';
    }

    set table(value: string) {
        this.#table = value;
        this.updateData()
    }


    private dsId: any = null;
    private dataSource: IObservable<View>|null = null;
    #subscription: any;

    constructor() {
        super();
    }


    render() {
        log(`pdq-data: ${this.id} ${this.show} - render`)
        if (this.show|| pdqHotkeyService.showPdqData.currentValue())
            return html`
                <div class="show col ${this.error ? 'error' : ''} m-1">
                    ${this.renderToolBar()}
                    <cds-textarea value="${this.dataPreview}">
                        <label slot="label-text">Dump:</label>
                    </cds-textarea>
                </div>
            `;
        return nothing;
    }
    protected async updateData() {
        const dsId = this.#table || this.#view;
        if (this.dsId !== dsId) {
            this.dsId = dsId
            if (this.#subscription){
                this.#subscription();
            }

            this.dataSource = pdqDataBroker.getViewOrTable(this.dsId)
            //this.dataSource = await pdqDataBroker.getOrCreateView(this.dsId)
            this.#subscription = this.dataSource.subscribe(async view => {
               const data = await view.to_json();
               this.dataPreview = JSON.stringify(data, null, 2);
               this.requestUpdate();
            });
        }
    }
}